import { DefaultService } from '@/services/DefaultService';

export default class AssUsuarioCentroCustoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    findAll(column, order, page, limit, situacao, idfin_centro_custo, ...params) {
        return this._http.get(
            encodeURI(`${this._env}/financeiro/ass-usuario-centro-custo.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idfin_centro_custo=${idfin_centro_custo}&param=${params}`), 
            this._headers
        )
        .then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    save(selecionados) {
        return this._http.post(`${this._env}/financeiro/ass-usuario-centro-custo`, selecionados, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }
    updateSituacao(obj) {
        return this._http.post(`${this._env}/financeiro/ass-usuario-centro-custo/updatesituacao`, obj, this._headers)
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }
    findUsuariosNaoAssociados(column, order, page, limit, idfin_centro_custo, ...params) {
        return this._http.get(
            encodeURI(
                `${this._env}/financeiro/ass-usuario-centro-custo/usuariosnaoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idfin_centro_custo=${idfin_centro_custo}&param=${params}`
            ), 
            this._headers 
        )
        .then(res => {
            return res.body;
        }, err => {
            this.handleError(err);
        });
    }
}